//
//
//
//
//
//

export default {
  name: 'App',
  created: function created() {
    // 百度网页统计js
    // var hm = document.createElement("script");
    // hm.src = "https://hm.baidu.com/hm.js?1d2d61263f13e4b288c8da19ad3ff56d";
    // var s = document.getElementsByTagName("script")[0];
    // s.parentNode.insertBefore(hm, s);

    // 加载接口文件
    this.$store.commit('apiurl/LOAD_API');
    this.$store.commit('apiurl2/LOAD_API');
  }
};